import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useApi } from "../../../../../hooks/useApi";
import { Textarea } from "../../../../Input/Textarea";
import DefaultModalLayout from "../../../../Modal/DefaultModalLayout";
import { DeleteModalLabel } from "../../../Users/UserDetail/CommentModal/CommentDeleteModal";

interface ChatReportRegisterModalProps {
  closeEvent: () => void;
  confirmEvent: () => void;
  chatKey: string;
}

export default function ChatReportRegisterModal({
  closeEvent,
  confirmEvent,
  chatKey,
}: ChatReportRegisterModalProps) {
  const [reason, setReason] = useState("");
  const [btnClick, setBtnClick] = useState(false);

  // 채팅 신고 처리하기
  const { response } = useApi({
    method: "post",
    url: btnClick ? `oldchat/report` : undefined,
    data: {
      key: chatKey,
      reason,
    },
  });

  console.log(response);

  useEffect(() => {
    if (response?.status === 201) {
      if (confirmEvent) {
        confirmEvent();
      }
      toast.success("채팅 신고 처리가 완료되었습니다.", {});
    }
  }, [response]);

  return (
    <DefaultModalLayout
      isSmallModal={true}
      modalTitle="채팅 신고 접수"
      closeEvent={() => closeEvent()}
      confirmEvent={() => setBtnClick(true)}
      confirmBtnText="완료"
    >
      <DeleteModalLabel>처리 내용</DeleteModalLabel>

      <Textarea
        placeholder="삭제 사유 입력(100글자 이내)"
        onChange={(e) => setReason(e.target.value)}
        value={reason}
      />
    </DefaultModalLayout>
  );
}
